import React from 'react';
import { Grid, Paper, Typography } from '@mui/material';
import PublicHeader from 'components/PublicHeader';
import IntlMessages from 'lngProvider/IntlMessages';
import FooterWrapper from 'components/Footer';
import { styled } from '@mui/material/styles';
import { getPaperStyleObject } from 'styles/Paper';

const StyledPaper = styled(Paper)((
    {
        theme
    }
    ) => {
        let paperStyle = getPaperStyleObject(theme);
        return {
            ...paperStyle.root
        };
    });

const PluginLoginConfirmed = () => {
    document.title = "3M VAS - Login";

    setTimeout(function () {
        window.opener = null;
        window.open("", "_self");
        window.close();
    }, 3000);

    return (
        <section>
            <PublicHeader />
            <Grid container alignItems="center" justifyContent="center">
                <Grid item xs={12}>
                    <Grid container alignItems="center" justifyContent="center" direction="column">
                        <Grid item xs={12}>
                            <StyledPaper>
                                <Grid container alignItems="center" justifyContent="center" direction="column" spacing={4}>
                                    <Grid item xs={12}>

                                        <Typography variant="h6" className="mt-4"><IntlMessages id="logIn.successful" /></Typography>

                                    </Grid>
                                </Grid>
                            </StyledPaper>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            <FooterWrapper />
        </section>
    );
};

export default PluginLoginConfirmed;